angular.
module("dx.webapp.clientVersion").
factory("dxClientVersionSort", function clientVersionSortService() {
	"use strict";

	return function clientVersionSort(left, right) {
		var versionPartsLeft = left.versionNumber.split(".");
		var versionPartsRight = right.versionNumber.split(".");

		for (var i = 0; i < versionPartsLeft.length; i++) {
			var result = parseInt(versionPartsRight[i], 10) - parseInt(versionPartsLeft[i], 10);

			if (result !== 0) {
				return result;
			}
		}

		return 0;
	};
});
